import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild} from '@angular/core';
import {NavigationService} from '../../services/navigation/navigation.service';
import {PageNames} from '../../shared/page-names.enum';
import {ModalConfig} from '../../model/modal-config';
import { KeyDirections } from '../../shared/key-directions.enum';
import { TvshopConstants } from '../../shared/tvshop-constants';

@Component({
  selector: 'app-terms-and-conditions-modal',
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrls: ['./terms-and-conditions-modal.component.less']
})

export class TermsAndConditionsModal implements AfterViewInit {

  @Input() config: ModalConfig;
  @Input() titleKey: string;
  @Input() descriptionKey: string;
  @Input() closeButtonTextKey: string;
  @ViewChild('termsandconditions', {read: ElementRef})
  voorwaarden: ElementRef;
  @Output()
  emitClose = new EventEmitter<Object>();
  @Output()
  emitOnBack = new EventEmitter<Object>();
  componentName = PageNames.TERMS_AND_CONDITIONS_MODAL;

  constructor(
    protected navigationService: NavigationService,
    private changeDetector: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.navigationService.resetNavigation();
    this.voorwaarden.nativeElement.focus();
    this.changeDetector.detectChanges();
  }

  public onEmitClose(): void {
    this.emitClose.emit({});
  }

  onBack(): void {
    this.onEmitClose();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.keyCode === KeyDirections.ARROW_DOWN) {
      this.voorwaarden.nativeElement.scroll(0, this.voorwaarden.nativeElement.scrollTop + TvshopConstants.SCROLL_TEXT_AMOUNT);
    }
    if (event.keyCode === KeyDirections.ARROW_UP) {
      this.voorwaarden.nativeElement.scroll(0, this.voorwaarden.nativeElement.scrollTop - TvshopConstants.SCROLL_TEXT_AMOUNT);
    }
  }
}
